import { render, staticRenderFns } from "./venta.vue?vue&type=template&id=0d748531&scoped=true"
import script from "./venta.vue?vue&type=script&lang=js"
export * from "./venta.vue?vue&type=script&lang=js"
import style0 from "./venta.vue?vue&type=style&index=0&id=0d748531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d748531",
  null
  
)

export default component.exports